import QuizIcon from "@mui/icons-material/Quiz";
import { useNavigate } from "react-router-dom";
import DashboardCard from "@/components/Common/DashboardCard";
import { useUnreviewedSubmissionsCount } from "@/hooks/useFormSubmissions";
import { TH_QUESTIONNAIRE_ID } from "./constants";

export default function HeadacheQuestionnairesCard() {
  const navigate = useNavigate();
  const {
    count: pendingQuestionnaires,
    loading,
    error,
  } = useUnreviewedSubmissionsCount(TH_QUESTIONNAIRE_ID);

  return (
    <DashboardCard
      title="Headache Questionnaires"
      description={
        loading
          ? "Loading..."
          : error
            ? "Error loading questionnaires"
            : pendingQuestionnaires > 0
              ? `${pendingQuestionnaires} questionnaire${pendingQuestionnaires === 1 ? "" : "s"} pending review`
              : "No pending questionnaires"
      }
      icon={<QuizIcon />}
      onClick={() => navigate("/questionnaire-review")}
      color="info"
      badge={
        !loading && !error && pendingQuestionnaires > 0
          ? pendingQuestionnaires
          : undefined
      }
    />
  );
}
